import { Components, Theme } from '@mui/material';

export const MuiCardHeader: Components<
  Omit<Theme, 'components'>
>['MuiCardHeader'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      padding: '16px 32px',

      backgroundColor: theme.palette.surfaceContainer.low,
      color: theme.palette.surface.onSurface,

      '& .MuiCardHeader-root': {
        backgroundColor: theme.palette.surfaceContainer.low,
      },

      '& .MuiCardHeader-content': {
        '& .MuiTypography-root': {
          fontFamily: 'Rubik',
          fontWeight: 500,
        },
      },
    }),
  },
};
